// WP-A · widget entry — mounts the App, wires Preact. Replaces the WP-00 stub.
import { render } from "preact";
import { App } from "./app.jsx";
import "./styles.css";

render(<App />, document.getElementById("root"));
